import BoutonPrincipal from './BoutonPrincipal';

function InfoJunior({ titre, texte, redirection, image, position = 'droite' }) {
  const isLeft = position === 'gauche';

  return (
    <div className="flex justify-center items-center my-20">
      <div className={`bg-gris-clair dark:bg-bleu-gris w-[90%] max-w-6xl h-auto flex flex-col lg:flex-row ${isLeft ? 'lg:flex-row-reverse' : ''} items-center p-6 rounded-2xl shadow-md`}>
        <img src={image} alt="" className={`w-full lg:w-[400px] h-auto object-cover mb-6 lg:mb-0 ${isLeft ? 'lg:ml-8' : 'lg:mr-8'}`}/>
        <div className="flex flex-col justify-center items-center gap-4 w-full lg:w-[60%]">
          <h3 className="text-bleu-footer dark:text-bleu-sombre text-2xl md:text-3xl font-semibold text-center">{titre}</h3>
          <p className="text-base md:text-lg font-normal text-justify">{texte}</p>
          <BoutonPrincipal titre={'En savoir plus'} lien={redirection}/>
        </div>
      </div>
    </div>
  );
}

export default InfoJunior;